import React from "react";
import { ReactComponent as DownArrowIcon } from "assets/icons/chevron-down.svg";
import clsx from "clsx";

const TableHeader = ({
  sortBy,
  setSortBy,
  isOrderedByDesc,
  setIsOrderedByDesc,
}) => {
  const handleSortObits = (value: string) => {
    if (sortBy === value) {
      setIsOrderedByDesc((prevState) => !prevState);
    } else {
      setSortBy(value);
      if (value === "deceasedName") {
        setIsOrderedByDesc(false);
      } else {
        setIsOrderedByDesc(true);
      }
    }
  };

  return (
    <div className="table-row-group w-full">
      <ul className="table w-full mb-5">
        <li
          onClick={() => handleSortObits("deceasedName")}
          className="hidden align-middle cursor-pointer md:table-cell text-obituary-brown-100 hover:underline"
        >
          <div className="flex items-center pl-[115px] w-full">
            <span>Sort by Name</span>
            {sortBy === "deceasedName" && (
              <DownArrowIcon
                className={clsx(
                  isOrderedByDesc ? "rotate-0" : "rotate-180",
                  "transition w-8 h-8 text-obituary-brown-100"
                )}
              />
            )}
          </div>
        </li>
        <li
          onClick={() => handleSortObits("deceasedBirthDate")}
          className="relative hidden md:table-cell text-right align-middle md:w-[10.75rem] px-2.5 py-1.5 text-obituary-brown-100 hover:underline cursor-pointer"
        >
          <div className="flex items-center justify-end w-full">
            <span className="mr-5">Sort by DOB</span>
            {sortBy === "deceasedBirthDate" && (
              <DownArrowIcon
                className={clsx(
                  isOrderedByDesc ? "rotate-0" : "rotate-180",
                  "transition absolute right-0 w-8 h-8 my-auto text-obituary-brown-100"
                )}
              />
            )}
          </div>
        </li>
        <li
          onClick={() => handleSortObits("deceasedDeathDate")}
          className="relative hidden md:table-cell text-right align-middle md:w-[10.75rem] px-2.5 py-1.5 text-obituary-brown-100 hover:underline cursor-pointer"
        >
          <div className="flex items-center justify-end w-full">
            <span className="mr-5">Sort by DOD</span>
            {sortBy === "deceasedDeathDate" && (
              <DownArrowIcon
                className={clsx(
                  isOrderedByDesc ? "rotate-0" : "rotate-180",
                  "transition absolute right-0 w-8 h-8 my-auto text-obituary-brown-100"
                )}
              />
            )}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default TableHeader;
